import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=55ca7dcd"
import script from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports